import { Outlet } from 'react-router-dom';

/**
 * Wraps the AuctiSync super-admin surface (`admin.auctisync.com`). Activates
 * `data-theme="super-admin"` — purple chrome + amber "god-mode" banner.
 */
export function SuperAdminLayout() {
  return (
    <div data-theme="super-admin" className="min-h-screen" style={{ background: 'var(--surface)' }}>
      <div
        role="banner"
        style={{
          background: 'var(--semantic-warning)',
          color: '#1a1a1a',
          padding: '0.5rem 1rem',
          fontSize: '0.75rem',
          fontWeight: 600,
          letterSpacing: '0.05em',
          textTransform: 'uppercase',
          textAlign: 'center',
        }}
      >
        Super Admin · Platform-wide controls · Act with care
      </div>
      <Outlet />
    </div>
  );
}
